// @todo collect all product ids in the project and place it in one place
export enum EServiceId {
    INTERNET = 5,
    KTV = 12,
    TELEPHONY = 31,
    CKTV = 32,
    DOMRUTV = 53,
}

export enum ECategoryId {
    others = 1,
    multimaster = 2,
    inGameContent = 3,
    content = 4,
    subscriptions = 5,
    watchControl = 6,
    parentControl = 7,
    antivirus = 8,
    constructor = 9,
    tvPacket = 10,
    equipment = 11,
    watchEverywhere = 12,
    multiroom = 13,
    saveHome = 14,
    insurance = 16,
    speedBonus = 18,
    ipAddress = 19,
    calls = 20,
    telephony = 21,
    suspension = 22,
    subscriptionFee = 23,
    stornoAdditional = 24,
    ppd = 441,
}

interface IChargeSubcategoryRA {
    ra: string,
    RaActiveFrom: string,
    RaActiveTo: string,
}

interface IChargeSubcategory {
    SubcategoryId: number,
    SubcategoryName: string,
    PlanName?: string,
    SubcategorySum: number,
    SubcategorySaleSum?: number,
    SubcategoryTotalSum: number,
    SubcategoryRa?: IChargeSubcategoryRA[],
    equipments?: string[],
}

export interface IChargeCategory {
    CategoryId: ECategoryId,
    CategoryName: string,
    CategorySum: number,
    CategorySaleSum?: number,
    CategoryTotalSum: number,
    CategoryNote?: string,
    subcategories: IChargeSubcategory[],
}

export interface IPeriodCharges {
    PeriodSum: number,
    PeriodSaleSum?: number,
    PeriodTotalSum: number,
    categories: IChargeCategory[],
}

export interface IHeaderInfo {
    AgrDate: string,
    AgrNumber: number,
    AgrPayTypeName: string,
    AgreementTypeName: string,
    ClientName: string,
    PeriodRow: string,
    PlansList: string,
    plans: Record<string, string>[],
}
